import { FlexCol } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { Button } from "@design-system/Inputs/Button";
import { useTranslation } from "react-i18next";
import { useEditorContext } from "../hooks/useEditor";
import { PDFViewer } from "./PDFViewer";

export default function BottomLeftBlock() {
    const { version } = useEditorContext();
    const { t } = useTranslation("EditDocument");
    const file = version?.finalFile;
    if (
        file?.signedUrl &&
        file.extension?.toLowerCase().replace(/^\./, "") === "pdf"
    ) {
        return <PDFViewer name={file.name ?? ""} url={file.signedUrl} />;
    }
    return (
        <FlexCol className="h-full p-8" alignItems="center" gap="4">
            <Text>{t(file?.signedUrl ? "no_preview" : "file_required")}</Text>
            {file?.signedUrl && (
                <Button
                    onClick={() =>
                        window.open(
                            file.signedUrl!,
                            "_blank",
                            "noopener,noreferrer",
                        )
                    }
                >
                    {t("download_document")}
                </Button>
            )}
        </FlexCol>
    );
}
